// extracted by mini-css-extract-plugin
export default {"content":"AssetInfo_content__17OAw","icon":"AssetInfo_icon__QFFdf"};